import React from 'react'

export default function EmojiPickerButton({ className, ariaLabel, displayPicker, renderEmojiIcon }) {
  return (
    <button type='button' aria-label={ariaLabel} className={className} onClick={(e) => displayPicker(e)}>
      {renderEmojiIcon()}
    </button>
  )
}
